import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import "../styles/products.css";

const Products = () => {
  const [products, setProducts] = useState([]);
  const { isAuthenticated } = useAuth();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const loadFallbackProducts = () => {
    // Use the homepage path for GitHub Pages
    const basePath = window.location.hostname === 'localhost' ? '' : '/hebaWebProj';
    fetch(`${basePath}/products.json`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load products.json');
        return res.json();
      })
      .then((data) => setProducts(data))
      .catch((err) => {
        console.error('Fallback fetch error:', err);
        // Set empty array if all fails
        setProducts([]);
      });
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    // API URL - use production backend when deployed, localhost for development
    // Check multiple conditions to ensure we use the right backend
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1' ||
                       window.location.hostname === '';
    
    const API_BASE_URL = process.env.REACT_APP_API_URL || 
      (isLocalhost ? 'http://localhost:5000' : 'https://hebawebproj.onrender.com');
    const API_URL = `${API_BASE_URL}/api/products`;

    console.log('🔗 Fetching products from:', API_URL);
    console.log('📍 Current hostname:', window.location.hostname);
    console.log('📍 Is localhost?', isLocalhost);
    console.log('📍 Full URL:', window.location.href);

    try {
      const response = await fetch(API_URL);
      const data = await response.json();
      if (data.success) {
        setProducts(data.data.products);
      } else {
        // Fallback to static JSON if API fails
        loadFallbackProducts();
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      // Fallback to static JSON if API fails
      loadFallbackProducts();
    }
  };

  const handleAddToCart = (product) => {
    if (!isAuthenticated()) {
      // Redirect to login page with current location for redirect after login
      navigate("/login", { state: { from: { pathname: "/products" } } });
      return;
    }

    // Add to cart if authenticated
    addToCart(product);
    // Optional: Show a success message
    alert(`${product.name} added to cart!`);
  };

  return (
    <div className="products-container">
      <h1 className="products-title">Our Products</h1>

      <div className="products-grid">
        {products.map((item) => (
          <div className="product-card" key={item.id}>
            <img className="product-img" src={item.image} alt={item.name} />

            <h3>{item.name}</h3>
            <p>{item.description || item.desc || ''}</p>
            <div className="product-price">${item.price}</div>

            <button 
              className="buy-btn" 
              onClick={() => handleAddToCart(item)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
